
export default {
  props: {
    lineupImage: {
      type: String,
      default: ``,
    },
    shareUrl: {
      type: String,
      default: ``,
    },
    twitterShareUrl: {
      type: String,
      default: ``,
    },
  },
  data () {
    return {
      copied: false,
    };
  },
  computed: {
    settings () {
      return this.siteSettings.lineup_predictor;
    },
  },
  methods: {
    copyShareUrl () {
      const input = this.domQs(`[data-share-url]`);

      input.select();
      input.setSelectionRange(0, 99999); // For mobile
      navigator.clipboard.writeText(input.value);

      this.copied = true;

      setTimeout(() => {
        this.copied = false;
      }, 2000);
    },
  },
};
